// src/Analytics.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const trackPageView = (url) => {
  if (window.gtag) {
    window.gtag("config", "G-6FZV01B8S5", {
      page_path: url,
    });
  }
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default Analytics;
